import React, { useState, useEffect } from "react";
import styles from "./App.module.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col } from "react-bootstrap";
import axios from "axios";
import { Check, X } from "./utils/buttons";
import Table from "react-bootstrap/Table";
import ToggleButton from "react-toggle-button";
import { apiEndpoint } from "./utils/common";
import Spinner from "react-bootstrap/Spinner";
import logo from "./assets/img/custom.png";
import noimage from "./assets/img/no-image.png";
import Dropzone from "react-dropzone";

export default function App() {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [projects, setProjects] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);

  const [medias, setMedias] = useState([]);
  const [selectedMedias, setSelectedMedias] = useState([]);

  const [overlays, setOverlays] = useState([]);
  const [selectedOverlays, setSelectedOverlays] = useState([]);

  const [selectUsers, setSelectUsers] = useState(true);
  const [selectProjects, setSelectProjects] = useState(false);
  const [selectMedia, setSelectMedia] = useState(false);
  const [selectDetectEngine, setSelectDetectEngine] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [projectName, setProjectName] = useState("");
  const [labelName, setLabelName] = useState([]);
  const [imageName, setImageName] = useState("");
  const [videoName, setVideoName] = useState("");

  const [waitInd, setWaitInd] = useState("");
  const [mediaUpdated, setMediaUpdated] = useState(false);
  const [mediaSync, setMediaSync] = useState(false);
  const [mediaId, setMediaId] = useState(0);
  const [engineFilter, setEngineFilter] = useState("cui_grade");
  const [autoSave, setAutoSave] = useState(false);


  useEffect(() => {
    async function fetchMe() {
    const posturl = "/api/huvr/users";
    const response = await axios.post(apiEndpoint() + posturl, { headers: { "content-type": "application/json" } });
    setUsers(response.data.results);
    setCompanyName("XaasLab");
    }
    fetchMe();
  }, []);

 function onClickActionUsers() {
   setSelectUsers(true);
   setSelectProjects(false);
   setSelectMedia(false);
   setSelectDetectEngine(false);
 }

 async function onClickActionProjects() {
   setSelectUsers(false);
   setSelectProjects(true);
   setSelectMedia(false);
   setSelectDetectEngine(false);
   setMediaUpdated(true);
   if (companyName !== "") {
   const posturl = "api/huvr/projects/" + companyName;
   const response = await axios.post(apiEndpoint() + posturl, { headers: { "content-type": "application/json" } });
   setProjects(response.data.results);
   setMediaUpdated(false);
   }

 }

 async function onClickActionMedia() {
   setSelectUsers(false);
   setSelectProjects(false);
   setSelectMedia(true);
   setSelectDetectEngine(false);
   setMediaUpdated(true);
   if (companyName !== "" && projectName !== "") {
   const posturl = "/api/huvr/inspectionmedia/" + projectName;
   const response = await axios.post(apiEndpoint() + posturl, { headers: { "content-type": "application/json" } });
   setMedias(response.data.results);
   setMediaUpdated(false);
   }

 }

 function onClickActionDetectEngine() {
   setLabelName([]);
   setWaitInd("");
   setSelectUsers(false);
   setSelectProjects(false);
   setSelectMedia(false);
   setSelectDetectEngine(true);
   setMediaUpdated(false);
 }

 async function onClickActionExecute() {
   setWaitInd("Execute");
   
   if (videoName !== "") {
      const url = "https://dev004.cognivea.com/detect/api/detect?engine=" + engineFilter;
      const obj = { media_url: videoName, startframe: "", endframe: "" };
      await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(obj) })
      .then(function (response) {
       return response.formData();
      })
      .then(function (formData) {
        console.log("");
      })
      .catch((error) => {
        console.log("Error :---", error);
        document.getElementById("test-5").value = error;
        setWaitInd("");
      });
    return;
   }
   document.getElementById("test-5").value = "";
      
   let nblob;
   let url = apiEndpoint() +"/static/test.jpg";
   url = apiEndpoint() + "/api/huvr/corsfix";
   await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(selectedMedias[0]) })
    .then(function (response) {
     return response.blob();
   })
   .then(function (blob) {
     nblob= blob;
   })
   .catch((error) => {
        console.log("Error :---", error);
        document.getElementById("test-5").value = error;
       setWaitInd("");
    });
   if (nblob !== undefined) {
   const form_data = new FormData();
   form_data.append("file", nblob, selectedMedias[0].name);
   // const posturl = "http://3.19.233.150:3000/api/detect?engine=corrosion_det";
   const posturl = "https://dev004.cognivea.com/detect/api/detect?engine=" + engineFilter;
   fetch(posturl, {
      method: "POST",
      body: form_data,
    })
   .then(response => {
        return response.formData();
    })
    .then((formData) => {
        for (const [key, data] of formData) {
          if (key === "labels") {
            return data;
          }
        }
     })
     .then((res) => {
        setLabelName(res);
        if (res === "[]") {
          document.getElementById("test-5").value = "Empty Label";
        }
        if (res !== "[]") {
         document.getElementById("test-5").value = res;
         if (autoSave === true) {
         onClickActionAutoSaveOverlay(res);
         }
  
        }
        setWaitInd("");
      })
      .catch((error) => {
        console.log("Error :---", error);
        document.getElementById("test-5").value = error;
       setWaitInd("");
      });
    }
 }

 async function onClickActionSaveOverlay() {
    if (!window.confirm("You are going to create overlay,seen on label box \nAre you sure?"))
         return;
   setWaitInd("Save");
   const objy = JSON.parse(labelName);
   console.log(objy);
   for (let i=0; i < objy.length; i++) {
   const url = "/api/huvr/inspectionmediaoverlay";
   const objx = { defect: { labels: [{ name: objy[i].label_type_name, value: "True" }] }, geometry: { type: "Polygon", coordinates: [[[objy[i].left, objy[i].top], [objy[i].right, objy[i].top], [objy[i].right, objy[i].bottom], [objy[i].left, objy[i].bottom], [objy[i].left, objy[i].top]]] }, asset: selectedProjects[0].asset.id };
   const obj = { media_id: selectedMedias[0].id, mode: "Create", value: JSON.stringify(objx), overlay_id: "" };
   const response = await axios.post(apiEndpoint() + url, obj, { headers: { "content-type": "application/json" } });
   console.log(response.data);
   if (response.status=== 200) {
     console.log(response.status);
   }
   }
   setMediaId(selectedMedias[0].id);
   setMedias([]);
   setSelectedMedias([]);
   setSelectedOverlays([]);
   setOverlays([]);
   setImageName("");
   setVideoName("");
   setLabelName([]);
   const posturl = "/api/huvr/inspectionmedia/" + projectName;
   const response = await axios.post(apiEndpoint() + posturl, { headers: { "content-type": "application/json" } });
   setMedias(response.data.results);
   setWaitInd("");
   setMediaSync(true);
 }

 async function onClickActionAutoSaveOverlay(res) {
   setWaitInd("Save");
   const objy = JSON.parse(res);
   console.log(objy);
   for (let i=0; i < objy.length; i++) {
   const url = "/api/huvr/inspectionmediaoverlay";
   const objx = { defect: { labels: [{ name: objy[i].label_type_name, value: "True" }] }, geometry: { type: "Polygon", coordinates: [[[objy[i].left, objy[i].top], [objy[i].right, objy[i].top], [objy[i].right, objy[i].bottom], [objy[i].left, objy[i].bottom], [objy[i].left, objy[i].top]]] }, asset: selectedProjects[0].asset.id };
   const obj = { media_id: selectedMedias[0].id, mode: "Create", value: JSON.stringify(objx), overlay_id: "" };
   const response = await axios.post(apiEndpoint() + url, obj, { headers: { "content-type": "application/json" } });
   console.log(response.data);
   if (response.status=== 200) {
     console.log(response.status);
   }
   }
   setMediaId(selectedMedias[0].id);
   setMedias([]);
   setSelectedMedias([]);
   setSelectedOverlays([]);
   setOverlays([]);
   setImageName("");
   setVideoName("");
   setLabelName([]);
   const posturl = "/api/huvr/inspectionmedia/" + projectName;
   const response = await axios.post(apiEndpoint() + posturl, { headers: { "content-type": "application/json" } });
   setMedias(response.data.results);
   setWaitInd("");
   setMediaSync(true);
 }

 async function onClickActionDeleteOverlay() {
    if (!window.confirm("You are going to delete the selected overlay \nAre you sure?"))
         return;
  setWaitInd("Delete");
   const url = "/api/huvr/inspectionmediaoverlay";
   const obj = { media_id: selectedMedias[0].id, mode: "Delete", value: "", defect_id: selectedOverlays[0].defect.id };
   const resp = await axios.post(apiEndpoint() + url, obj, { headers: { "content-type": "application/json" } });
   if (resp.status=== 200) {
    console.log(resp.status);
   }
   setMediaId(selectedMedias[0].id);
   setMedias([]);
   setSelectedMedias([]);
   setSelectedOverlays([]);
   setOverlays([]);
   setImageName("");
   setVideoName("");
   setLabelName([]);
   const posturl = "/api/huvr/inspectionmedia/" + projectName;
   const response = await axios.post(apiEndpoint() + posturl, { headers: { "content-type": "application/json" } });
   setMedias(response.data.results);
   setWaitInd("");
   setMediaSync(true);

 }

 async function onClickActionUpload(acceptedFiles: Array<File>, rejectedFiles: Array<File>) {
   const file = acceptedFiles[0];

   const url = "/api/huvr/uploadinspectionmedia";
   const obj = { project: selectedProjects[0].id, media_type: file.type, filename: file.name };
   const resp = await axios.post(apiEndpoint() + url, obj, { headers: { "content-type": "application/json" } });
   if (resp.status === 200) {
    console.log(resp.status);
   }

   const uploadurl = "/api/huvr/uploadfile";
   const form_data = new FormData();
   const objx = { url: resp.data.upload.url, headers: file.type };
   const content = JSON.stringify(objx);
   const blob = new Blob([content], { type: "application/json" });
   form_data.append("dlr-info", blob, "dlrinfo.json");
   const xblob = new Blob([file], { type: "application/octet-stream" });
   form_data.append("dlr-file", xblob, file.name);
   const res = await axios.post(uploadurl, form_data, { headers: { "content-type": "multipart/form-data" } });
   if (res.status === 200) {
    console.log(resp.status);
    window.alert("Upload Successful");
   }
   setSelectedMedias([]);
   setSelectedOverlays([]);
   setOverlays([]);
   setImageName("");
   setVideoName("");
   setLabelName([]);
   const posturl = "/api/huvr/inspectionmedia/" + projectName;
   const response = await axios.post(apiEndpoint() + posturl, { headers: { "content-type": "application/json" } });
   setMedias(response.data.results);
   setWaitInd("");
  }

 async function onClickActionDeleteMedia() {
    if (!window.confirm("You are going to delete the selected media \nAre you sure?"))
         return;
  setWaitInd("Delete");
   const url = "/api/huvr/deleteinspectionmedia";
   const obj = { media_id: selectedMedias[0].id };
   const resp = await axios.post(apiEndpoint() + url, obj, { headers: { "content-type": "application/json" } });
   if (resp.status=== 200) {
    console.log(resp.status);
   }
   setMediaId(selectedMedias[0].id);
   setMedias([]);
   setSelectedMedias([]);
   setSelectedOverlays([]);
   setOverlays([]);
   setImageName("");
   setVideoName("");
   setLabelName([]);
   const posturl = "/api/huvr/inspectionmedia/" + projectName;
   const response = await axios.post(apiEndpoint() + posturl, { headers: { "content-type": "application/json" } });
   setMedias(response.data.results);
   setWaitInd("");
   setMediaSync(true);

 }

 async function executeMediaSync() {
   setMediaSync(false);
   for (let i=0; i < medias.length; i++) {   
     if (mediaId === medias[i].id) {
       onMediasSelectedChanged(medias[i]);
       break;
     }
   }
 }

 async function onClickCopyLink() {
navigator.clipboard.writeText(videoName).then(
  () => {
    /* clipboard successfully set */
window.alert("URL Link Copied to Clipboard");
  },
  () => {
    /* clipboard write failed */
  },
);
  
 }


 function onUsersSelectedChanged(info: ResultSheet) {
    setSelectedProjects([]);
    setSelectedMedias([]);
    setSelectedOverlays([]);
    setProjects([]);
    setMedias([]);
    setOverlays([]);
    const index = selectedUsers.indexOf(info);
    if (index >= 0) {
      setSelectedUsers(selectedUsers => [
        ...selectedUsers.slice(0, index),
        ...selectedUsers.slice(index + 1),
      ]);
      setCompanyName("");
    } else {
      setSelectedUsers([]);
      setSelectedUsers(selectedUsers => [...selectedUsers, info]);
      if (info.company.length > 0) {
         setCompanyName(info.company[0].name);
      }
    }
  } 

 function onProjectsSelectedChanged(info: ResultSheet) {
    const index = selectedProjects.indexOf(info);
    if (index >= 0) {
      setSelectedProjects(selectedProjects => [
        ...selectedProjects.slice(0, index),
        ...selectedProjects.slice(index + 1),
      ]);
      setProjectName("");
    } else {
      setSelectedProjects([]);
      setSelectedProjects(selectedProjects => [...selectedProjects, info]);
      setProjectName(info.id);
      setSelectedMedias([]);
      setSelectedOverlays([]);
      setMedias([]);
      setOverlays([]);
    }
  } 

 function onMediasSelectedChanged(info: ResultSheet) {
    const index = selectedMedias.indexOf(info);
    if (index >= 0) {
      setSelectedMedias(selectedMedias => [
        ...selectedMedias.slice(0, index),
        ...selectedMedias.slice(index + 1),
      ]);
    } else {
      setSelectedMedias([]);
      setSelectedMedias(selectedMedias => [...selectedMedias, info]);
      setOverlays(info.overlays);
      setVideoName("");
      setImageName("");
      console.log(info);
      if (info.media_type.startsWith("video")) {
        setVideoName(info.alternate_media.file);
    
      }
      if (info.media_type.startsWith("image")) {
       setImageName(info.file);
      }
    }
  } 

 function onOverlaysSelectedChanged(info: ResultSheet) {
    const index = selectedOverlays.indexOf(info);
    if (index >= 0) {
      setSelectedOverlays(selectedOverlays => [
        ...selectedOverlays.slice(0, index),
        ...selectedOverlays.slice(index + 1),
      ]);
    } else {
      setSelectedOverlays([]);
      setSelectedOverlays(selectedOverlays => [...selectedOverlays, info]);
    }
  } 

  function handleEngineFilter(e: SyntheticKeyboardEvent<HTMLInputElement>) {
     let x="none";
     switch (e.currentTarget.value.trim()) {

       case "1":
            x = "cui_grade";
            break;

       case "2":
            x = "corrosion_det";
            break;

       case "3":
            x = "metal-crack";
            break;

       default:
            break;

     }
     setEngineFilter(x);
  }

  async function handleEditor(tabStr:string, e: SyntheticKeyboardEvent<HTMLInputElement>) {
    switch (tabStr) {

    case "AUTO-SAVE":
         setAutoSave(!autoSave);
         break;


    default:
      break;
    }
  }
 
  return <div className={styles.root}>
 <img className= {styles.logo_img} src= {apiEndpoint() + logo} alt="logo_image" />
  <div style={{ marginLeft: "3%", marginRight: "2%", marginTop: "10px" }}>
  <h5>HUVR API Intergration Framework for Detect Engine</h5>
  </div>
   {mediaSync === true && executeMediaSync()}
   <Form style={{ marginLeft: "10%", marginRight: "4%" }}>
        <Form.Row>
          { selectedUsers.length === 0 &&
             <Col xs="auto">
               <h6>{"User"} Name : {"Not Selected"}</h6>
             </Col>
          }

          { selectedUsers.length > 0 &&
             <Col xs="auto">
               <h6>{"User"} Name : {selectedUsers[0].name}</h6>
             </Col>
          }
          { selectedProjects.length > 0 &&
             <Col xs="auto">
               <h6>{"Project"} Name : {selectedProjects[0].name}</h6>
             </Col>
          }
          { selectedMedias.length > 0 &&
             <Col xs="auto">
               <h6>{"Media"} Name : {selectedMedias[0].name}</h6>
             </Col>
          }
        </Form.Row>
      </Form>

 <Form style={{ marginLeft: "4%", marginRight: "4%" }}>
        <Form.Row>
          <Col>
            <Button variant={"secondary"} size="sm" block disabled={selectUsers} onClick={() => onClickActionUsers()}>
            Users
            </Button>
          </Col>
          <Col>
            <Button variant={"secondary"} size="sm" block disabled={selectProjects} onClick={() => onClickActionProjects()}>
            Projects
            </Button>
          </Col>
          <Col>
            <Button variant={"secondary"} size="sm" block disabled={selectedProjects.length === 0 || selectMedia} onClick={() => onClickActionMedia()}>
            Media
            </Button>
          </Col>
          <Col>
            <Button variant={"secondary"} size="sm" block disabled={selectedProjects.length === 0 || selectedMedias.length === 0 || selectDetectEngine} onClick={() => onClickActionDetectEngine()}>
            Detect Engine
            </Button>
          </Col>
        </Form.Row>
      </Form> 

  
 {selectUsers === true && <>

 <h5 style={{ marginTop: "20px", marginBottom: "10px", textAlign: "center" }}>{"User Information"}</h5>
 <Form style={{ marginLeft: "2%", marginRight: "2%" }}>
   <Form.Row>
    <Col xs="auto">
              <Button variant={"secondary"} size="sm" block disabled={selectedUsers.length === 0} >
              Send Email
              </Button>
          </Col>
    <Col xs="auto">
              <Button variant={"secondary"} size="sm" block disabled={selectedUsers.length === 0} >
              Detect Engine
              </Button>
          </Col>

  </Form.Row>
  <Form.Row>

 <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Select</th>
              <th>Name</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Display Name</th>
              <th>User Name</th>
              <th>Date Joined</th>
              <th>Company Name</th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 && users.map(x =>
              <tr key={x.id}>
                <td className={styles.cellsize}>
                  <ToggleButton
                  inactiveLabel={<X />}
                  activeLabel={<Check />}
                  value={selectedUsers.indexOf(x) >= 0 || (selectedUsers.length > 0 && x.id === selectedUsers[0].id)}
                  onToggle={() => onUsersSelectedChanged(x)} />  
                </td>
                <td>{x.name}</td>
                <td>{x.first_name}</td>
                <td>{x.last_name}</td>
                <td>{x.email}</td>
                <td>{x.display_name}</td>
                <td>{x.username}</td>
                <td>{new Date(Date.parse(x.date_joined)).toLocaleString()}</td>
                <td>{x.company.length > 0 ? x.company[0].name:""}</td>

              </tr>)
            }
          </tbody>
        </Table>
 </Form.Row>
  </Form>

  </> }


 {selectProjects === true && mediaUpdated === true && 
 <h5 style={{ marginTop: "100px", textAlign: "center" }}>
 
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Retrieving Project Information Wait ...</h5>  
 }

 {selectProjects === true && mediaUpdated === false && projects.length === 0 && 
   <h5 style={{ fontSize: "small", marginTop: "0px", textAlign: "center" }}> No Projects found</h5>  
 }

 {selectProjects === true && mediaUpdated === false && projects.length > 0 && <>
 <h5 style={{ marginTop: "20px", marginBottom: "10px", textAlign: "center" }}>{"Project Information"}</h5>
 <Form style={{ marginLeft: "2%", marginRight: "2%" }}>
   <Form.Row>
    <Col xs="auto">
              <Button variant={"secondary"} size="sm" block disabled={selectedProjects.length === 0} >
              Upload Report
              </Button>
          </Col>

    <Col xs="auto">
              <Button variant={"secondary"} size="sm" block disabled={selectedProjects.length === 0} >
              Download Report
              </Button>
          </Col>
<Col xs="auto">
              <Button variant={"secondary"} size="sm" block disabled={selectedProjects.length !== 0} >
              Statistics
              </Button>
          </Col>

<Col xs="auto">
              <Button variant={"secondary"} size="sm" block disabled={selectedProjects.length !== 0} >
              Charts
              </Button>
          </Col>

  </Form.Row>
  <Form.Row>

 <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Select</th>
              <th>Name</th>
              <th>Management Company Name</th>
              <th>Management Role</th>
              <th>Date Joined</th>
            </tr>
          </thead>
          <tbody>
            {projects.length > 0 && projects.map(x =>
              <tr key={x.id}>
                <td className={styles.cellsize}>
                  <ToggleButton
                  inactiveLabel={<X />}
                  activeLabel={<Check />}
                  value={selectedProjects.indexOf(x) >= 0 || (selectedProjects.length > 0 && x.id === selectedProjects[0].id)}
                  onToggle={() => onProjectsSelectedChanged(x)} />  
                </td>
                <td>{x.name}</td>
                <td>{x.management_company !== null ?x.management_company.name:""}</td>
                <td>{x.management_company !== null ?x.management_company.role:""}</td>
                <td>{new Date(Date.parse(x.created_on)).toLocaleString()}</td>
              </tr>)
            }
          </tbody>
        </Table>

  </Form.Row>
  </Form>
   </>}

 {selectMedia === true && mediaUpdated === true && 
 <h5 style={{ marginTop: "100px", textAlign: "center" }}>
 
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Retrieving Media Information Wait ...</h5>  
 }
 {selectMedia === true && mediaUpdated === false && medias.length === 0 && 
   <h5 style={{ fontSize: "small", marginTop: "0px", textAlign: "center" }}> No Media found</h5>  
 }

 {selectMedia === true && mediaUpdated === false && medias.length > 0 && <>

 <h5 style={{ marginTop: "20px", marginBottom: "10px", textAlign: "center" }}>{"Media Information"}</h5>
 <Form style={{ marginLeft: "2%", marginRight: "2%" }}>
   <Form.Row>
<Col xs="auto">
 <Dropzone multiple={false} onDrop={(accepted, rejected) => onClickActionUpload(accepted, rejected)}>
              {({ getRootProps, getInputProps }) => {
              const rootProps = { ...getRootProps() };
              delete rootProps.tabIndex;
              return <span {...rootProps}>
                <input {...getInputProps()} />
              <Button variant={"secondary"} size="sm" block disabled={selectedMedias.length !== 0} >
              Upload
              </Button>
              </span>;
              }}
              </Dropzone> 
   
          </Col>
<Col xs="auto">
              <Button variant={"secondary"} size="sm" block disabled={selectedMedias.length !== 0} >
              Statistics
              </Button>
   
          </Col>

<Col xs="auto">
              <Button variant={"secondary"} size="sm" block disabled={selectedMedias.length !== 0} >
              Charts
              </Button>
   
          </Col>

  </Form.Row>
  <Form.Row>
 <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Select</th>
              <th>Name</th>
              <th>Media</th>
              <th>Media-Type</th>
              <th>Link Media</th>
              <th>Select Options</th> 
            </tr>
          </thead>
          <tbody>
            {medias.length > 0 && medias.map(x =>
              <tr key={x.id}>
                <td className={styles.cellsize}>
                  <ToggleButton
                  inactiveLabel={<X />}
                  activeLabel={<Check />}
                  value={selectedMedias.indexOf(x) >= 0 || (selectedMedias.length > 0 && x.id === selectedMedias[0].id)}
                  onToggle={() => onMediasSelectedChanged(x)} />  
                </td>
                <td>{x.name}</td>
                {(x.media_type.includes("image") || x.media_type.includes("video")) ? 
                 <td> <img src= {x.thumbnail} alt= "Download Error" /></td>
                :<td> <img src= {noimage} alt= "Download Error" /></td>}
                <td>{x.media_type}</td>
                <td>  
                  <Form>
                  <Form.Row>
                      <Col xs="auto">
                        <Button variant={"secondary"} size="sm" block disabled={true}>
                        Download
                       </Button>
                     </Col>
                    </Form.Row>
                  </Form>
                </td>

                {selectedMedias.length > 0 && x.id === selectedMedias[0].id &&
                <td>  
                  <Form>
                    <Form.Row>
                      <Col xs="auto">
                        <Button variant={"secondary"} size="sm" block disabled={true}>
                        Overlay View
                       </Button>
                     </Col>
                      <Col xs="auto">
                        <Button variant={"secondary"} size="sm" block disabled={true}>
                        Delete
                       </Button>
                     </Col>
                      <Col xs="auto">
                        <Button variant={"secondary"} size="sm" block disabled={true}>
                        Download
                       </Button>
                     </Col>
                    
                    </Form.Row>
                  </Form>
                </td>}
                {selectedMedias.length > 0 && x.id !== selectedMedias[0].id && <td></td>}
                {selectedMedias.length === 0 && <td></td>}
              </tr>)
            }
          </tbody>
        </Table>
  </Form.Row>
 </Form>     

   </> }


 {selectDetectEngine === true && <>
 <div style={{ marginLeft: "4%", marginRight: "4%", marginTop: "50px" }}>
 <Form>
    <Form.Row>

         <Col xs="auto">
           <h6 style={{ fontSize: "small", marginTop: "0px", textAlign: "center" }}> Select Engine</h6>  
          </Col>

         <Col xs="auto">
  <select id={"test-6"} onChange={(e) => handleEngineFilter(e)} disabled={false}>
                      {[<option key={"X1"} value={1} selected>{"CUI_Grade"}</option>,
                        <option key={"X2"} value={2}>{"Corrosion"}</option>,
                        <option key={"X3"} value={3}>{" Metal Crack"}</option>,
                        <option key={"X4"} value={4}>{"B"}</option>,
                        <option key={"X5"} value={5}>{"C"}</option>,
                        <option key={"X6"} value={6}>{"D"}</option>,
                        <option key={"X7"} value={8}>{"E"}</option>,
                        <option key={"X8"} value={8}>{"F"}</option>,
                       ]}
                   </select>
          </Col>

  <Col xs="auto">
     {waitInd === "" && 
                <Button variant={"secondary"} size="sm" block disabled={false} onClick={() => onClickActionExecute()}>
                Execute
                </Button>
      }
     {waitInd === "Execute" && 

      <Button variant={"secondary"} size="sm" >
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Processing Wait ...
                </Button>
      }

          </Col>
 <Col xs="auto">
           <h6 style={{ fontSize: "small", marginTop: "0px", textAlign: "center" }}> Label Information</h6>
 </Col>

 <Col xs="auto">


                 <span><textarea id={"test-5"} style={{ resize: "none" }} rows="8" cols="60" disabled={false} placeholder= {""} >{labelName}</textarea></span>
          </Col>
          <Col xs="auto">
          <Form.Check type="checkbox" label="AutoSave" checked={autoSave !== false} onChange={(e) => handleEditor("AUTO-SAVE", e)} />
          </Col>

 <Col xs="auto">
     {waitInd === "" && autoSave === false &&
                <Button variant={"secondary"} size="sm" block disabled={labelName.length===0} onClick={() => onClickActionSaveOverlay()}>
                Save
                </Button>
      }
     {waitInd === "Save" && autoSave === false &&

      <Button variant={"secondary"} size="sm" >
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Saving Wait ...
                </Button>
      }

          </Col>
<Col xs="auto">
 <Dropzone multiple={false} onDrop={(accepted, rejected) => onClickActionUpload(accepted, rejected)}>
              {({ getRootProps, getInputProps }) => {
              const rootProps = { ...getRootProps() };
              delete rootProps.tabIndex;
              return <span {...rootProps}>
                <input {...getInputProps()} />
              <Button variant={"secondary"} size="sm" block disabled={false} >
              Upload CSV (Demo)
              </Button>
              </span>;
              }}
              </Dropzone> 
   
          </Col>

    </Form.Row>
</Form>

 <h5 style={{ marginTop: "10px", textAlign: "center" }}>{"Asset: "}{selectedProjects[0].asset.asset_path}</h5>

 <Form>
    <Form.Row>

     {waitInd === "" && 

         <Col xs="auto">
   <Button variant={"secondary"} size="sm" block disabled={selectedOverlays.length === 0} onClick={() => onClickActionDeleteOverlay()}>
                Delete
                </Button>
          </Col>
}
     {waitInd === "Delete" && 

      <Button variant={"secondary"} size="sm" >
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Deleting Wait ...
                </Button>
      }
 
    </Form.Row>
</Form>
 <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Select</th>
              <th>Created Date</th>
              <th>Label (Value)</th>
              <th>Type</th>
              <th>LT</th>
              <th>RT</th>
              <th>RB</th>
              <th>LB</th>
              <th>LT</th>
            </tr>
          </thead>
          <tbody>
            {overlays.length > 0 && overlays.map(x =>
              <tr key={x.id}>
                <td className={styles.cellsize}>
                  <ToggleButton
                  inactiveLabel={<X />}
                  activeLabel={<Check />}
                  value={selectedOverlays.indexOf(x) >= 0 || (selectedOverlays.length > 0 && x.id === selectedOverlays[0].id)}
                  onToggle={() => onOverlaysSelectedChanged(x)} />  
                </td>
                <td>{new Date(Date.parse(x.created_on)).toLocaleString()}</td>
                {x.defect === null && <>
                <td>{""}</td>
                </>}
                {x.defect !== null && x.defect.labels.length > 0 && <>
                <td>{x.defect.labels[0].name}{"["}{x.defect.labels[0].value}{"]"}</td>
                </>}

                {x.geometry === null && <>
                  <td>{""}</td>
                  <td>{""}</td>
                  <td>{""}</td>
                  <td>{""}</td>
                  <td>{""}</td>
                  <td>{""}</td>
                </>}
                {x.geometry !== null && <>
                  <td>{x.geometry.type}</td>
                  <td>{parseInt(x.geometry.coordinates[0][0][0])}{" , "}{parseInt(x.geometry.coordinates[0][0][1])}</td>
                  <td>{parseInt(x.geometry.coordinates[0][1][0])}{" , "}{parseInt(x.geometry.coordinates[0][1][1])}</td>
                  <td>{parseInt(x.geometry.coordinates[0][2][0])}{" , "}{parseInt(x.geometry.coordinates[0][2][1])}</td>
                  <td>{parseInt(x.geometry.coordinates[0][3][0])}{" , "}{parseInt(x.geometry.coordinates[0][3][1])}</td>
                  <td>{parseInt(x.geometry.coordinates[0][4][0])}{" , "}{parseInt(x.geometry.coordinates[0][4][1])}</td>
                  </>}
              </tr>)
            }
          </tbody>
        </Table>

  <div style={{ marginLeft: "4%", marginRight: "4%", marginTop: "50px", marginBottom: "100px" }}>
   {imageName !== "" &&
    <img src= {imageName} alt="logo_image" />
   }
  {videoName !== "" && <>
   <textarea id="w3review" name="w3review" rows="4" cols="50">{videoName}</textarea>
   <div>
   <video width="800" height="600" src={videoName} controls>
    </video>
   </div>
  </> }
  </div>
 </div>


 </>
 }

  </div>;
}